import firebase from 'firebase/app'
import 'firebase/analytics'
import 'firebase/remote-config'
import 'firebase/messaging'

/** 👇 checking url query params to disable firebase messaging */
const queryUrl = window.location.search
const isDisableFirebase = queryUrl?.includes('disable-firebase')

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MASSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
}

firebase.initializeApp(firebaseConfig)

/** 👇 firebase disable for mobile flutter web view */
let messaging = null
if (!isDisableFirebase) {
  if (firebase.messaging.isSupported()) {
    messaging = firebase.messaging()
  }
}

const analytics = firebase.analytics()

const remoteConfig = firebase.remoteConfig()
// remoteConfig.settings.minimumFetchIntervalMillis = 3600000
remoteConfig.settings.minimumFetchIntervalMillis = 0

export { messaging, remoteConfig, analytics }
